import React, { useCallback } from 'react'
import { useHistory } from 'react-router-dom'
import { PrivacySubjectSearch } from './PrivacySubjectSearch'
import './PrivacyList.css'
import './PrivacySubjectSearch.css'

function SearchShieldIcon() {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden
    >
      <circle cx="11" cy="11" r="8" />
      <path d="m21 21-4.3-4.3" />
    </svg>
  )
}

/**
 * Módulo A-09: checklist de baja de usuario × empresa.
 * Vive bajo Privacidad en el menú (`/privacidad/localizar`).
 */
export function PrivacySubjectSearchPage() {
  const history = useHistory()

  const openCreateCase = useCallback(
    (prefill) => {
      history.push({
        pathname: '/privacidad',
        state: { createPrefill: prefill },
      })
    },
    [history],
  )

  return (
    <div className="privacy-page privacy-subject-search-page">
      <div className="page-header">
        <div>
          <h1 className="page-title">
            <SearchShieldIcon /> Baja de usuario
          </h1>
          <p className="privacy-subject-page-subtitle">
            Checklist antes de quitar el acceso: revisa accesos, membresía,
            contactos, credenciales y archivos del usuario en la empresa.
          </p>
        </div>
      </div>

      <PrivacySubjectSearch onCreateCase={openCreateCase} />
    </div>
  )
}

export default PrivacySubjectSearchPage
